<template lang="pug">
  v-timeline(align-top, dense)
    v-timeline-item(color="teal accent-3", icon="edit")
      v-row.pt-1
        v-col
          strong {{ renderCreatorDate() }}
    
    v-timeline-item(
      v-if="item.ipForm == 'BIB-HSE-PPO-IZIN-TAMU'",
        :icon="config.status[item.ipVisitorStatus].icon",
        :color="config.status[item.ipVisitorStatus].color"
      )
        v-row.pt-1
          v-col
            strong Submitted Visitor

    //- Workflow Items for all forms
    v-timeline-item(
      v-for="(workflow, index) in workflowList",
      :key="workflow.date",
      :color="getWorkflowColor(workflow)",
      :icon="getWorkflowIcon(workflow)"
    )
      v-row.pt-1(v-if="workflow.status == 7 || workflow.status == 8")
        v-col
          strong(v-if="workflow.admin_reject == true") {{ getWITADate(workflow.date) }} - {{ config.status[workflow.status].name }} by {{ workflow.admin_detail.name }} ({{ workflow.admin_detail.title }}) as Admin
          strong(v-else) {{ renderWorkflowDetail(workflow, index) }}
          .caption.mb-2 {{ workflow.comment }}
          div.mt-4
            ModalListApprover(:approver="getWorkflowApprover(workflow, index)")

      v-row.pt-1(v-else)
        v-col
          strong {{ renderApprovalNeed(workflow, index) }}
          div.mt-4
            ModalListApprover(:approver="getWorkflowApprover(workflow, index)")

    

    //- Final Closing / Pengesahan / Done Timeline for 'item.ipPengesahan'
    v-timeline-item(
      v-if="item.ipPengesahan && item.ipStatus == 12 && !this.item.ipPengesahan.ipWorkflow[0]",
      :icon="'fact_check'",
      :color="'teal accent-3'"
    )
      v-row.pt-1
        v-col
          strong {{ renderPengesahanClosing(0) }}

    //- Handle the second pengesahan closing
    v-timeline-item(
      v-if="item.ipPengesahan && item.ipStatus == 12 && !this.item.ipPengesahan.ipWorkflow[1]",
      :icon="'fact_check'",
      :color="'teal accent-3'"
    )
      v-row.pt-1(v-if="item.ipPengesahan && item.ipStatus == 12")
        v-col
          strong {{ renderPengesahanClosing(1) }}
      v-row.pt-1(v-else)
        v-col
          strong Close

    //- Final Closing / Pengesahan / Done Timeline Item
    v-timeline-item(
      v-if="isFinalTimelineVisible",
      :icon="finalTimelineIcon",
      :color="finalTimelineColor"
    )
      v-row.pt-1
        v-col
          strong {{ finalTimelineText }}

    //- Additional for pengesahan
    v-timeline-item(
      v-if="item.ipPengesahan && item.ipStatus != 12 ",
      :icon="''",
      :color="'grey'"
    )
      v-row.pt-1
        v-col
          strong Close
   

</template>

<script>
import dayjs from 'dayjs';
import ModalListApprover from "../components/modal/ListApprover.vue"; // Import ModalListApprover

export default {
  name: "TimelineItemsAdmin",
  components: {
    ModalListApprover,
  },
  props: {
    item: Object,
    config: Object,
    getWITADate: Function,
    timelineDetail: Function,
    getNameApproverKTT: Function,
    getTitleApprover: Function,
    formType: String,
    isExtendWaskat: Function,
  },
  computed: {
    workflowList() {
      // Handle form workflow types
      if (this.formType === 'BIB-HSE-PPO-FRM-018-03' && this.item.ipExtendWorkflow) {
        return this.item.ipExtendWorkflow;
      }
      return this.item.ipWorkflow || [];
    },
    isFinalTimelineVisible() {
      // Determine if the final timeline item should be visible
      return true; // this.item.ipStatus === 12 || this.item.ipExtendStatus === 12 || this.item.ipPengesahan;
    },
    finalTimelineIcon() {
      // Determine the icon for the final timeline item
      if (this.item.ipStatus === 10 ||this.item.ipStatus === 11||this.item.ipStatus === 12 || this.item.ipExtendStatus === 12) {
        return 'fact_check';
      }
      return '';
    },
    finalTimelineColor() {
      // Determine the color for the final timeline item
      if (this.item.ipStatus === 10 ||this.item.ipStatus === 11||this.item.ipStatus === 12 || this.item.ipExtendStatus === 12) {
        return 'teal accent-3';
      }
      return 'grey';
    },
    finalTimelineText() {
      // Special handling for item.ipWorkflow.length === 4 and BIB-HSE-PPO-F-012-01
      if (this.item.ipWorkflow.length === 4 && this.item.ipForm === 'BIB-HSE-PPO-F-012-01') {
        if (this.item.ipStatus === 10 || this.item.ipStatus === 11 || this.item.ipStatus === 12) {
          return `${this.getWITADate(this.item.ipClosingDate)} - Closed by ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
        }
        return 'Close';
      }

      // Special for BIB-HSE-PPO-F-071-02 or any form that needs "Closing Submitted"
      if (this.item.ipForm === 'BIB-HSE-PPO-F-071-02' || this.item.ipForm === 'BIB-HSE-PPO-F-071-01') {
        if (this.item.ipStatus === 10 || this.item.ipStatus === 11 || this.item.ipStatus === 12) {
          return `${this.getWITADate(this.item.ipPengesahan ? this.item.ipPengesahan.ipClosingSubmitted : this.item.ipClosingDate)} - Closing Submitted by ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
        }
        return 'Closing Submitted';
      }

      // Special for BIB-HSE-PPO-IZIN-TAMU (Visitor Form)
      if (this.item.ipForm === 'BIB-HSE-PPO-IZIN-TAMU') {
        if (this.item.ipStatus === 12 && dayjs().isAfter(dayjs(this.item.ipSelesaiKunjungan))) {
          return 'Close';
        }
      }

      // If ipPengesahan exists and ipStatus == 12, render final closing
      if (this.item.ipPengesahan && this.item.ipStatus === 12) {
        if (this.item.ipPengesahan.ipWorkflow && this.item.ipPengesahan.ipWorkflow[1]) {
          return `${this.getWITADate(this.item.ipClosingDate)} - Closed by ${this.item.ipPengesahan.ipWorkflow[1].name} (${this.item.ipPengesahan.ipWorkflow[1].title}) as ${this.timelineDetail(this.item.ipPengesahan.ipWorkflow[1].postAs, 1, this.item.ipForm)}`;
        }
        if (this.item.ipPengesahan.ipWorkflow && this.item.ipPengesahan.ipWorkflow[0]) {
          return `${this.getWITADate(this.item.ipClosingDate)} - Closed by ${this.item.ipPengesahan.ipWorkflow[0].name} (${this.item.ipPengesahan.ipWorkflow[0].title}) as ${this.item.ipPengesahan.ipWorkflow[0].matrix[0] || 'PNC' }`;
        }
        return 'Close';
      }

      // If ipExtendStatus exists and done
      if (this.item.ipExtendStatus === 12 || this.item.ipForm === 'BIB-HSE-PPO-FRM-018-03') {
        return 'Done';
      }

      // General close
      if (this.item.ipPengesahan && this.item.ipStatus === 10 || this.item.ipStatus === 11 || this.item.ipStatus === 12) {
        return `${this.getWITADate(this.item.ipPengesahan.ipClosingSubmitted)} - Closing Submited by ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
      }
      if (!this.item.ipPengesahan && this.item.ipStatus === 10 || this.item.ipStatus === 11 || this.item.ipStatus === 12) {
        return `${this.getWITADate(this.item.ipClosingDate)} - Closed by ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
      }

      // Default fallback
      return 'Close';
    },
  },
  methods: {
    renderCreatorDate() {
      // Combine the logic for Creator info
      const date = this.formType === "Extend Waskat" ? this.item.ipExtendDate : this.item.ipDate;
      const status = this.formType === "Extend Waskat" ? this.item.ipExtendStatus : this.item.ipStatus;
      return `${this.getWITADate(date)} - ${status == 1 ? 'Drafted by' : 'Submitted by'} ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
    },
    getWorkflowColor(workflow) {
      // Set color for workflow items
      return this.config.status[workflow.status].color;
    },
    getWorkflowIcon(workflow) {
      // Set icon for workflow items
      return this.config.status[workflow.status].icon;
    },
    renderWorkflowDetail(workflow, index) {
      // Handle workflow detail for specific forms like 'BIB-HSE-PPO-F-071-02'
      if (this.item.ipForm === 'BIB-HSE-PPO-F-071-02' && workflow.matrix && workflow.matrix.includes('KTT')) {
        return `${this.getWITADate(workflow.date)} - ${this.config.status[workflow.status].name} by ${this.getNameApproverKTT(workflow)} (Kepala Teknik Tambang) as ${this.timelineDetail(workflow.postAs, index, this.item.ipForm)}`;
      }
      return `${this.getWITADate(workflow.date)} - ${this.config.status[workflow.status].name} by ${this.getNameApproverKTT(workflow)} (${this.getTitleApprover(workflow)}) as ${this.timelineDetail(workflow.postAs, index, this.item.ipForm)}`;
    },
    renderApprovalNeed(workflow, index) {
      // Render workflow that needs approval
      return `${workflow.status == 9 ? 'Need Approval by ' : ''}${this.timelineDetail(workflow.postAs, index, this.item.ipForm)}`;
    },
    getWorkflowApprover(workflow, index) {
      // Determine workflow approver based on postAs
      if (workflow.postAs === 'waskat' && this.item.ipWaskats) {
        return [this.item.ipWaskats[index]];
      }
      return workflow.listApprover || [];
    },
    renderPengesahanClosing(position) {
      // Handle pengesahan closing for positions
      const workflow = this.item.ipPengesahan.ipWorkflow[position];
      if (!workflow) return this.renderDefaultClosing();
      console.log(workflow);
      return `${this.getWITADate(this.item.ipClosingDate)} - Closed by ${workflow.name} (${workflow.title || workflow.position}) as ${this.timelineDetail(workflow.postAs, position, this.item.ipForm)}`;
    },
    renderDefaultClosing() {
      // Default closing message
      return `${this.getWITADate(this.item.ipPengesahan.ipClosingSubmitted)} - Closing Submited by ${this.item.ipUser.name} (${this.item.ipUser.title}) as Creator`;
    },
  },
};
</script>
